import React from "react";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const DeleteModal = ({
  handleDeleteModalClose,
  data,
  onDelete,
  isDeleting,
}) => {
  return (
    <div>
      <ModalContainer handleClose={handleDeleteModalClose}>
        <div className={`${cssStyles.modalContainer} ${cssStyles.wideModal}`}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-3">
            <p className="fs-4 fw-medium m-0 black-text">Confirm Delete</p>
            <span
              className="bg-dark bg-opacity-75 d-flex p-3 rounded-5"
              role="button"
              onClick={handleDeleteModalClose}
              style={{ cursor: "pointer" }}
            >
              <FaCircleXmark />
            </span>
          </div>

          <div className="w-100">
            <p className="black-text mb-0">
              Do you want to delete <b>{data.name}</b>?
            </p>

            <div className={cssStyles.actionButtons}>
              <div
                className={`${cssStyles.actionButton} bg-dark`}
                role="button"
                onClick={handleDeleteModalClose}
              >
                Cancel
              </div>

              <div
                className={`${cssStyles.actionButton} ${
                  isDeleting ? "bg-dark-subtle" : "bg-danger"
                }`}
                role="button"
                onClick={() => {
                  if (isDeleting) return;
                  onDelete(data.slug);
                }}
              >
                {isDeleting ? <BeatLoader size={10} color="#fff" /> : "Delete"}
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default DeleteModal;
